import { Controller } from '@hotwired/stimulus'
import { polite } from 'helpers/live_region_helper'
import { tableSelectionChanged } from '../../../helpers/custom_events_helper'

const INTERACTIVE_ELEMENTS = 'a, button, input, label, select, textarea, [role="button"]'

export default class extends Controller {
  static targets = ['supercheckbox', 'rowCheckbox']

  navigate(event) {
    if (event.target.closest(INTERACTIVE_ELEMENTS)) return

    const row = event.target.closest('tr[data-row-url]')
    if (!row) return

    const url = row.dataset.rowUrl

    if (event.ctrlKey || event.metaKey) {
      window.open(url, '_blank')
    } else if (window.Turbo) {
      window.Turbo.visit(url)
    } else {
      window.location.href = url
    }
  }

  toggleRow(event) {
    const row = event.target.closest('tr')
    if (!row) return

    const selected = event.target.checked
    row.classList.toggle('table__row--selected', selected)
    this._updateSupercheckbox()
    this._fireSelectionChanged()

    const header = row.querySelector('th')
    if (header) {
      polite.setContent(`Row ${header.textContent.trim()} ${selected ? 'selected' : 'unselected'}`)
    }
  }

  toggleAll(event) {
    this._setAll(event.target.checked)
  }

  deselectAll() {
    this._setAll(false)
  }

  get selectionData() {
    return this.rowCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => JSON.parse(checkbox.dataset.selectionValue))
  }

  addSelectionChangeListener(callback) {
    this.element.addEventListener('table:selectionChanged', callback)
  }

  _setAll(checked) {
    this.rowCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
      const row = checkbox.closest('tr')
      if (row) row.classList.toggle('table__row--selected', checked)
    })

    if (this.hasSupercheckboxTarget) {
      this._updateSupercheckboxValue(checked)
    }

    this._fireSelectionChanged()
    polite.setContent(checked ? 'All rows selected' : 'All rows unselected')
  }

  _fireSelectionChanged() {
    tableSelectionChanged(this.element, { selection: this.selectionData })
  }

  _updateSupercheckbox() {
    const total = this.rowCheckboxTargets.length
    const checked = this.rowCheckboxTargets.filter((cb) => cb.checked).length

    this._updateSupercheckboxValue(total > 0 && checked === total)
  }

  _updateSupercheckboxValue(checked) {
    if (!this.hasSupercheckboxTarget) return

    this.supercheckboxTarget.checked = checked
    const labelContainer = this.supercheckboxTarget.previousElementSibling
    const newLabelText = checked ? 'Unselect All' : 'Select All'
    if (labelContainer.textContent !== newLabelText) {
      labelContainer.textContent = newLabelText
    }
  }
}
